import { Shark, Utils, View } from "shark-mvc";

import ClientFollowUp from "../../_shark_models/ClientFollowUp";
import SiteInfoSheetEditViewBase from "./SiteInfoSheetEditViewBase";

import templateContent from "./site-info-sheet-outdoor-edit.html";

import contactDetailsModalComponent from "../../components/contactDetailsModal/contactDetailsModalComponent";
import contactFinderComponent from "../../components/contactFinder/contactFinderComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import siteInfoSheetListView from "./siteInfoSheetListView";
import { siteInfoSheetManager } from "../../_shark_jaws/managers/siteInfoSheetManager";
import { userManager } from "../../_shark_jaws/managers/userManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class SiteInfoSheetOutdoorEditView extends SiteInfoSheetEditViewBase {
	constructor () {
		super("siteInfoSheetOutdoorEditView");
		this.setTemplate(templateContent);
	}

	//Dave: Serve?
	actualWallSupportNature06_changeHandler () {
		if (Shark.get("#actualWallSupportNature06").prop("checked")) {
			Shark.get("#actualWallSupportNaturesHumidityPercentBox").show();
		}
		else {
			Shark.get("#actualWallSupportNaturesHumidityPercentBox").hide();
		}
	}

	addPremiseDestinationBtn_clickHandler () {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
		
		currSiteInfoSheet.systems.push(siteInfoSheetManager.createPremiseDestination());
		//Dave: questa è una superSchifezza che andrà gestita, la proprietà non diventa dirty se faccio il push "a mano.":
		currSiteInfoSheet.__dirtyProperties.push({ property: "premiseDestination", originalValue: currSiteInfoSheet.systems });
		siteInfoSheetManager.reindexSystem(currSiteInfoSheet);

		this.set({
			__registerCollapseOpen: true//Dave: Che è? Serve ancora?
		});
		console.log(currSiteInfoSheet)
		Shark.render();
	}

	addSystemBtn_clickHandler (event, data) {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
		const systemIndex = data.index;

		currSiteInfoSheet.systems[systemIndex].systems.push(siteInfoSheetManager.createSystem());
		//Dave: questa è una superSchifezza che andrà gestita, la proprietà non diventa dirty se faccio il push "a mano.":
		currSiteInfoSheet.__dirtyProperties.push({ property: "systems", originalValue: currSiteInfoSheet.systems });
		siteInfoSheetManager.reindexSystem(currSiteInfoSheet);

		this.set({
			__registerCollapseOpen: true//Dave: Che è? Serve ancora?
		});
		console.log(currSiteInfoSheet);
		Shark.render();
	}

	afterRender () {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

		if (currSiteInfoSheet) {
			this.parseFormForEditing();
		}
		else {
			Shark.openPage(siteInfoSheetListView);
		}
	}

	applicatorTeamId_changeHandler (event) {
		const applicatorTeamList = Shark.get("applicatorTeamList");
		const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", event.target.value);

		if (currApplicatorTeam) {
			const checkApplicatorTeamCalendarBtn = document.querySelector("#checkApplicatorTeamCalendarBtn");
		
			checkApplicatorTeamCalendarBtn.href = currApplicatorTeam.calendarURL;
			checkApplicatorTeamCalendarBtn.classList.remove("d-none");
		}
		else {
			checkApplicatorTeamCalendarBtn.href = "";
			checkApplicatorTeamCalendarBtn.classList.add("d-none");
		}
	}

	//Dave: cmq non è bello che se metto l'handler del click sul super si rompe il "this", da capire
	backToListBtn_clickHandler () {
		this.cancelEdits();
	}

	beforeLoad () {
		this.beforeLoadCommon("outdoor");
	}

	beforeRender () {
		this.set({
			__nextPictureSaveName: Shark.__generateGUID()
		});
	}
	
	beforeUnload () {
		this.set({
			cancelEditsDestination: null,
			afterSaveDestination: null,
		});
		Shark.set({
			isEditingSiteInfoSheet: false,
		});
	}

	cancelEditsBtn_clickHandler () {
		this.cancelEdits();
	}

	clientManager_contactSelectedHandler () {
		siteInfoSheetOutdoorEditView.setContactFromContactFinderForRole();
	}

	clsFinishRadios_changeHandler () {
		if (Shark.get("#clsFinish3").prop("checked")) {
			Shark.get("#clsFinishFurtherInfoBox").show();
		}
		else {
			Shark.get("#clsFinishFurtherInfoBox").hide();
		}
	}

	hasHydrostaticPressure_changeHandler () {
		if (Shark.get("#hasHydrostaticPressure").prop("checked")) {
			Shark.get("#hasHydrostaticPressureFurtherInfoBox").show();
		}
		else {
			Shark.get("#hasHydrostaticPressureFurtherInfoBox").hide();
		}
	}

	init () {
		this.addComponents([contactDetailsModalComponent, contactFinderComponent, exportPDFComponent, followUpComponent, mainNavComponent, printButtonComponent, waitBoxComponent]);

		Shark.set({
			applicatorTeamList: Shark.get("applicatorTeamList") || [],
		});
	}

	// preparation10_changeHandler () {
	// 	if (Shark.get("#preparation10").prop("checked")) {
	// 		Shark.get("#preparationsFurtherInfoBox").show();
	// 	}
	// 	else {
	// 		Shark.get("#preparationsFurtherInfoBox").hide();
	// 	}
	// }

	removeContactReferenceBtn_clickHandler (event, data) {
		if (this.removeContactReference(data.type)) {
			Shark.render();
		}
	}

	removePremiseDestinationBtn_clickHandler (event, data) {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
		const premiseIndex = data.index;

		currSiteInfoSheet.systems.splice(premiseIndex, 1);
		//Dave: questa è una superSchifezza che andrà gestita, la proprietà non diventa dirty se faccio il push "a mano.":
		currSiteInfoSheet.__dirtyProperties.push({ property: "premiseDestination", originalValue: currSiteInfoSheet.systems });
		siteInfoSheetManager.reindexSystem(currSiteInfoSheet);

		Shark.render();
	}

	removeSystemBtn_clickHandler (event, data) {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
		const premiseIndex = data.index;
		const systemIndex = data.subIndex;

		currSiteInfoSheet.systems[premiseIndex].systems.splice(systemIndex, 1);
		//Dave: questa è una superSchifezza che andrà gestita, la proprietà non diventa dirty se faccio il push "a mano.":
		currSiteInfoSheet.__dirtyProperties.push({ property: "systems", originalValue: currSiteInfoSheet.systems });
		siteInfoSheetManager.reindexSystem(currSiteInfoSheet);

		Shark.render();
	}

	saveSiteInfoSheetBtn_clickHandler () {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");
		if (currSiteInfoSheet.isDirty()) {
			if (siteInfoSheetManager.checkForSave()) {
				waitBoxComponent.open();

				let revision = currSiteInfoSheet.revision;
				let originalGuid = currSiteInfoSheet.guid;
	
				if (typeof revision === "number") {
					revision++;
				}
				else {
					revision = 0;
				}
	
				currSiteInfoSheet.set({
					guid: "",
					revision,
					revisionReferenceGuid: currSiteInfoSheet.revisionReferenceGuid !== "" ? currSiteInfoSheet.revisionReferenceGuid : currSiteInfoSheet.guid
				});

				const referenceAgent = Utils.safp(Shark.get("agentList"), "guid", currSiteInfoSheet.userGuid);
				const currUser = Shark.get("currUser");
	
				siteInfoSheetManager.save(currSiteInfoSheet)
				.then(() => {
					siteInfoSheetManager.archive(originalGuid)
					.then(() => {
						const body = `BuonGiorno ${referenceAgent.firstName},
							
							questa eMail per comunicare che ${currUser.__fullName} ha inserito <strong>una nuova revisione (rev. ${currSiteInfoSheet.revision})</strong> della Scheda Informativa del <strong>${currSiteInfoSheet.__referenceDate}</strong> per <strong>${currSiteInfoSheet.registry.clientName}</strong>.
	
							Puoi visualizzare le Schede Informative <a href="${Shark.get("agentAppURL")}/#quotationListView">cliccando qui</a>.
	
							Buona Giornata,
							IPM HUB
						`;
	
						const currMessage = Shark.getInstance(null, {
							body,
							senderEMail: currUser.email,
							senderName: currUser.__fullName,
							subject: "IPM HUB | Revisione Scheda Informativa inserita",
							receiverEMail: referenceAgent.email,
							receiverName: referenceAgent.__fullName,
						});
						userManager.sendMessage(currMessage);
	
						const newFollowUp = new ClientFollowUp({
							body: "Creata una nuova revisione per la Scheda Informativa '" + currSiteInfoSheet.getAutoFolderName() + "' (rev. " + currSiteInfoSheet.revision + ").",
							clientGuid: currSiteInfoSheet.clientGuid,
							referenceGuid: currSiteInfoSheet.revisionReferenceGuid,
							referenceType: "siteInfoSheet",
							status: 3,
							type: "system"
						});
				
						followUpManager.save(newFollowUp)
						.then(sharkResponse => {
							console.log({sharkResponse});
						});
	
						Shark.set({
							refreshSiteInfoSheetListNeeded: true,
						});
						waitBoxComponent.close();
	
						Shark.openPage(siteInfoSheetListView);
					});
				});
			}
		}
		else {
			alert("Non ci sono modifiche da salvare");
		}
	}
	
	//Dave: questo bottone va rinominato
	setContactAsReceiverBtn_clickHandler (event, data) {
		this.copyDataFromContact(data.type);
	}
}

const siteInfoSheetOutdoorEditView = new SiteInfoSheetOutdoorEditView();

Shark.registerView(siteInfoSheetOutdoorEditView);

export default siteInfoSheetOutdoorEditView;
